export interface LeadershipEntry {
  id: string;
  company_id: number;
  full_name: string;
  title: string | null;
  bio: string | null;
  headshot_url: string | null;
  linkedin_url: string | null;
  email: string | null;
  order_position: number;
  source: string;
  is_manual_override: boolean;
  created_at: string;
}

export interface LeadershipCreatePayload {
  full_name: string;
  title?: string;
  bio?: string;
  linkedin_url?: string;
  email?: string;
  order_position?: number;
}

export interface LeadershipUpdatePayload {
  full_name?: string;
  title?: string;
  bio?: string;
  linkedin_url?: string;
  email?: string;
  order_position?: number;
}

export interface DemoVideoEntry {
  id: string;
  company_id: number;
  title: string;
  video_url: string;
  thumbnail_url: string | null;
  description: string | null;
  duration_seconds: number | null;
  order_position: number;
  created_at: string;
}

export interface DemoVideoCreatePayload {
  title: string;
  video_url: string;
  thumbnail_url?: string;
  description?: string;
  duration_seconds?: number;
  order_position?: number;
}

export interface DemoVideoUpdatePayload {
  title?: string;
  video_url?: string;
  thumbnail_url?: string;
  description?: string;
  duration_seconds?: number;
  order_position?: number;
}

export interface FieldOverrideMeta {
  overridden_at: string;
  overridden_by: string;
}

export type ManualOverridesMap = Record<string, FieldOverrideMeta>;

export const OVERRIDABLE_FIELDS = [
  'name',
  'description',
  'website',
  'founding_year',
  'employees',
  'industry',
  'location',
  'target_market',
  'traction_stage',
  'revenue_range',
  'geographic_focus',
  'funding_stage',
  'total_funding',
  'is_private',
] as const;

export type OverridableFieldName = (typeof OVERRIDABLE_FIELDS)[number];

export interface CompanyFieldOverridePayload {
  fields: Record<string, any>;
}
